<template>
  <div class="contato">
    <header-primary title="Contato" :image="require('../assets/background/bg_line_phone_contato.jpg')" subtitle="Veja como entrar em contato com a VirteX"></header-primary>
    <section class="container mt-5 mb-5">
      <md-content class="md-layout bg-transparent">
        <div class="text-primary md-layout-item col-12 col-lg-6">
          <h4 class="md-headline mb-1">Local</h4>
          <iframe
            frameborder="0" class="map-style mb-2"
            :src="`https://www.google.com/maps/embed/v1/place?key=${mapa.chave}
    &q=${ coordenadaGoogle }`" allowfullscreen>
          </iframe>
          <h6 class="foot-tel mt-1">
            <i class="material-icons mr-1">location_on</i>
            <span class="flex-column d-flex">
                <span class="pb-1 md-subheading">{{
                  `${ sharedState.cityInfo.endereco.local },
                  ${ sharedState.cityInfo.endereco.numero }
                  ${sharedState.cityInfo.endereco.bairro}`
                  }}</span>
                <span class="mt-0 md-subheading">{{
                  `${ sharedState.cityInfo.endereco.cidade }-${ sharedState.cityInfo.endereco.uf },
                  ${sharedState.cityInfo.endereco.cep}` }}</span>
              </span>
          </h6>
          <h4 class="md-headline mt-2 mb-3">S.A.C.</h4>
          <h6 class="foot-tel mt-0 mb-1">
            <i class="material-icons mr-1">phone</i>
            <span class="pb-1 m-0  md-subheading">{{ sharedState.cityInfo.fixo }}</span>
          </h6>
          <h4 class="md-headline mt-2 mb-3">Telefones</h4>
          <h6 class="foot-tel mt-0 mb-1" v-for="tel in sharedState.cityInfo.pabx" :key="tel">
            <i class="material-icons mr-1">phone</i>
            <span class="pb-1 m-0  md-subheading">{{ tel }}</span>
          </h6>
          <h4 class="mt-3 md-headline mt-2 mb-3">Atendimento Online</h4>
          <h6 class="foot-tel mt-0 mb-2">
            <i class="socicon-telegram mr-1" style="font-size: 24px"></i>
            <span class="pb-2 md-subheading">{{ sharedState.cityInfo.telegram.num }}</span>
          </h6>
          <h4 class="md-headline mb-1 mt-2 mt-0">Aplicativo VirteX</h4>
          <a target="_blank" href="https://play.google.com/store/apps/details?id=ninja.venal.virtexapp">
            <img width="150px" src="../assets/icon/google_play_badge.png" alt="Google Play Badge - VirteX App">
          </a>

        </div>
        <div class="col-12 col-lg-6">
          <h4 class="md-headline mb-1 text-primary">Ligamos para Você!</h4>
          <FormCallToYou />
        </div>
      </md-content>
    </section>
    <social-bar class-color="bg-dark" :mod="true" :telegram="sharedState.cityInfo.telegram.id"></social-bar>
  </div>
</template>

<script>
  import HeaderPrimary from "../components/HeaderPrimary";
  import SocialBar from '../components/SocialBar'
  import FormCallToYou from "../components/FormCallToYou";



  export default {
    name: "Contato",
    components: {FormCallToYou, HeaderPrimary, SocialBar},
    data() {
      return {
        sharedState: this.$store.state,
        mapa: {
          chave: 'AIzaSyA55oFCQ8PFRulSpCG6Eioa7nyg9-WFkF0'
        }
      }
    },
    computed: {
      coordenadaGoogle() {
        let coord = this.sharedState.cityInfo.endereco.coordenada;
        return `${coord.lat}, ${coord.lon}`
      }
    }
  }
</script>

<style scoped>
  .map-style {
    width: 100%;
    height: 200px;
    border: 2px solid #cc0000;
  }
</style>
